import BaseField from "./BaseField";
import MultiselectValue from "./MultiselectValue";
import ReactDOM from "react-dom";

export class MultiselectField extends BaseField {
    constructor(props) {
        super(props);
    }

    removeValue(id){
        this.props.collectMultiSelectData(this.props.Values, id, false);
    }

    renderSelectedValues(){
        if(this.props.Values !== null){
            return this.props.Values.map((value, index) => {
                if(value.Selected){
                    let title = value.Title;
                    return (
                        <div className="jobsToApply" key={index}>
                            <span>
                                {title}
                            </span>
                            <span className="delete__icon" onClick={(e) => {this.removeValue(value.ID)}}/>
                        </div>
                    )
                }
            })
        }
    }

    renderValues() {
        if(this.props.Values === null){
            return null;
        }
        return this.props.Values.map((value, index) => {
            return <MultiselectValue
                state={this.props.Values}
                isSelected={value.Selected}
                key={index}
                ID={value.ID}
                Title={value.Title}
                collectData={this.props.collectData}
                collectMultiSelectData={this.props.collectMultiSelectData}
                PreselectedValue={this.props.PreselectedValue}
            />
        })
    }

    modalID(){
        return this.props.id + "Modal";
    }

    modalTriggerID(){
        return "#" + this.props.id + "Modal";
    }

    renderModal(){
        const modal = (
            <div className="modal typography" tabIndex="-1" id={this.modalID()}>
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content rounded-md border-0">
                        <div className="modal-header">
                            <h5 className="mb-0">
                                {this.props.Placeholder}
                            </h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"/>
                        </div>
                        <div className="modal-body">
                            <div className="container mb-5">
                                <div className="row">
                                    {this.renderValues()}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
        return ReactDOM.createPortal(modal, document.body);
    }

    render(){
        return(
            <div className={this.props.Columns}>
                {this.renderModal()}
                <div className="multiselectField mb-3 mb-md-4 mb-xl-5">
                    <div id={this.props.id} className="field multiselect">
                        <label className="">
                            {this.renderLabelText()}
                        </label>
                        <div className="multiselect__field bg-white p-3 rounded-md">
                            {this.renderSelectedValues()}
                            <button type="button" className="text-muted pointer" data-bs-toggle="modal" data-bs-target={this.modalTriggerID()}>
                                {this.props.Placeholder}
                            </button>
                        </div>
                        {this.renderErrorMessage()}
                    </div>
                </div>
            </div>
        )
    }
}
export default MultiselectField;
